import "@fontsource-variable/source-sans-3";
import styles from "./CodeChip.module.css";

/**
 * An analysis's short code (SSD, CS3D, ...) as an app-icon tile in the analysis's own
 * colour, `tint`. The one tile for the 123BIMLive story, the scene's readout and the home
 * page's analyses list; each sets its size with --chip-size.
 */
export default function CodeChip({ code, tint }) {
  return (
    <span
      className={styles.chip}
      style={{ "--tint": tint }}
      data-long={code.length > 3 ? "" : undefined}
    >
      {code}
    </span>
  );
}
